import { env } from '../../common/util'

const financialSummary = { dev: 'eiaibj6g6uuxmfbu', staging: 'eudwatduwtujes7r', prod: '2tspyef3f59unqyl' }
const followUpEmail = { dev: 'aur41tqdihe9u1kd', staging: 'dxq0qfghf7kekksd', prod: 'ekg2bcro6o85d6qw' }

export const TEMPLATE_TYPE_MAPPING = {
  [financialSummary[env]]: 'Summary template',
  [followUpEmail[env]]: 'E-mail template',
}
